<script lang="ts" setup>
import LocationForm from '@/components/locations/LocationForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { LocationsActions, LocationsState } from '@/stores/locations.store';
import { Location } from '@/models/location.model';
import { useEvents, Event } from '@/services/events.composable';
import TranslatedState from '../common/TranslatedState.vue';
import ListFilter from '../common/ListFilter.vue';

const store = useStore<ShiftCMSState & { los: LocationsState }>();
const items = computed<Location[]>(() => store.state.los.items);
const events = useEvents();

const update = () => {
  store.dispatch(LocationsActions.GetLocations);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editLocation = (_: Event, { item }: { item: Location }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(LocationForm),
    data: item,
  });
};

const addLocation = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(LocationForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '20%' },
  { title: 'Type', key: 'type', width: '15%' },
  { title: 'Radius', key: 'radius', width: '5%' },
  { title: 'Parent', key: 'parentLocation.name', width: '15%' },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<Location[]>(() => {
  return items.value.filter((v: Location) => {
    if (filterTitle.value) {
      return [v.name]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;

  console.log(filters.filter, filters.filterTitle);
}
</script>

<template>
  <v-container>
    <h2>Locations</h2>
    <ListFilter dense :options="[]" @filter="updateFilter" />
    <v-data-table
      density="compact"
      @click:row="editLocation"
      :headers="headers"
      :items="filteredItems"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.creationDate="{ value }">
        {{ format(value, 'do MMMM yyyy - HH:mm') }}
      </template>
      <template v-slot:item.translated="{ item }">
        <div style="display: flex; flex-direction: row">
          <translated-state :item="item" />
        </div>
      </template>
    </v-data-table>

    <v-btn @click="addLocation" color="success">Add Location</v-btn>&nbsp;
  </v-container>
</template>
